import jwt_decode from 'jwt-decode';

interface DecodedToken {
  organizationId?: string;
  userId?: string;
  perms?: string[];
}

export const requirePopulatedJWT = () => window.location.hostname.endsWith('.marley.ai');

export const validateAccessToken = (token: string) => {
  const decodedToken = jwt_decode(token) as DecodedToken;

  const {
    organizationId,
    userId,
    perms,
  } = decodedToken;
  const missingFields = [];

  if (!organizationId) {
    missingFields.push('Organization ID');
  }
  if (!userId) {
    missingFields.push('User ID');
  }
  if (!perms) {
    missingFields.push('User Permissions');
  }

  if (missingFields.length > 0) {
    console.error(`[Token Manager] Missing required fields or contains empty fields: ${missingFields.join(', ')}`);
    return false;
  }
  console.log('[Token Manager] Access token is valid');
  return true;
};
